import { render } from "./Billing.vue?vue&type=template&id=98803c8e"
import script from "./Billing.vue?vue&type=script&lang=js"
export * from "./Billing.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__